var React = require('react');

function FlagSr (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z","fill":"#73af00","key":0}),React.createElement("g",{"fill":"#f5f5f5","key":1},React.createElement("path",{"d":"M0 150.071h512v35.31H0zM0 326.621h512v35.31H0z"})),React.createElement("path",{"fill":"#c8414b","d":"M0 185.381h512v141.24H0z","key":2}),React.createElement("path",{"d":"M253.801 201.615l-12.854 38.541-40.627.314c-2.228.018-3.15 2.86-1.359 4.183l32.683 24.135-12.255 38.737c-.672 2.124 1.746 3.881 3.559 2.585L256 286.485l33.053 23.625c1.812 1.295 4.23-.461 3.559-2.585l-12.255-38.737 32.683-24.135c1.792-1.323.868-4.166-1.359-4.183l-40.627-.314-12.854-38.541c-.706-2.113-3.694-2.113-4.399 0z","fill":"#ffe15a","key":3})]);
}

FlagSr.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagSr;

FlagSr.default = FlagSr;
